import axios from 'axios';
import router from '@/router';
import Cookies from 'js-cookie';

import { VUE_APP_FILE_URL } from '@/utilities/constants.js';

const instance = axios.create({ VUE_APP_FILE_URL });

instance.interceptors.request.use(
  function(request) {
    const listOfPublicViews = [
      '/view-projects',
      '/profile',
      '/showcase',
      '/invitation',
      '/signup',
      '/direct-registration',
      '/latest-members',
      '/latest-showcases',
      '/latest-itineraries',
      '/profile-showcases'
    ];

    const bearerToken = Cookies.get('bearerToken');
    const ksToken = Cookies.get('ksBearerToken');

    const publicMode =
      listOfPublicViews.some(route => {
        return window.location.href.includes(route);
      }) && !bearerToken;

    if (
      request.url !== VUE_APP_FILE_URL + '/auth/login' &&
      !request.url.includes('member-Ofs') &&
      !publicMode
    ) {
      request.headers['Authorization'] = ksToken || bearerToken;
    }
    return request;
  },
  function(err) {
    return Promise.reject(err);
  }
);

instance.interceptors.response.use(undefined, function(err) {
  return new Promise(() => {
    const listOfPublicViews = [
      '/view-projects',
      '/profile',
      '/showcase',
      '/invitation',
      '/signup',
      '/direct-registration',
      '/latest-members',
      '/latest-showcases'
    ];

    if (err && err.response) {
      const validPath = listOfPublicViews.some(route => {
        return window.location.href.includes(route);
      });

      if (
        err.response.status === 401 &&
        !validPath &&
        !err.response.request.responseURL.includes('/auth/user')
      ) {
        const intendedRoute = window.location.pathname;
        const lastRoute = localStorage.getItem('lastRoute');

        const route =
          intendedRoute !== '/login' || '/dashboard'
            ? intendedRoute
            : lastRoute;

        router.push(`/login?routeTo=${route}`);
      }
    }

    throw err;
  });
});

export default instance;
